import pdf1 from '../../assets/pdf/Sinhala H2H Incorporated by Act No.10 of 2024 by the Parliament of SL.pdf'
import pdf2 from '../../assets/pdf/English H2H Incorporated by Act No.10 of 2024 by the Parliament of SL .pdf'
import pdf3 from '../../assets/pdf/Tamil H2H IIncorporated by Act No.10 of 2024 by the Parliament of SL.pdf'


const data = [
    {
        path: pdf1
    },
    {
        path: pdf2
    },
    {
        path: pdf3
    }
]

export default data;
